import CRUDFormComponent from '../../components/CRUDFormComponent'

const ProffessionsForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Profesión' }}
        fields={fields}
        entityUrl="/professions"
      />
    </>
  )
}

export default ProffessionsForm
